/* eslint-disable import/prefer-default-export */
import { takeLatest, put, all } from 'redux-saga/effects' // eslint-disable-line
import getOneTraineesBySectorActions, {
    getOneTraineesTypes,
} from '../../../redux/collectData/getOneTraineesBySector'
import { Get } from '../../../serveur/axios'

function* getOneTraineesBySectorSagas({ response }) {
    try {
        const responseGet = yield Get(
            `collect_data/graduate_training/${response.id}`
        )
        if (responseGet.status === 200 || responseGet.status === 201) {
            yield all([
                yield put(
                    getOneTraineesBySectorActions.getOneTraineesSuccess(
                        responseGet.data.data
                    )
                ),
            ])
        } else {
            yield put(
                getOneTraineesBySectorActions.getOneTraineesFailure(
                    responseGet.data
                )
            )
        }
    } catch (error) {
        yield put(getOneTraineesBySectorActions.getOneTraineesFailure(error))
    }
}

export function* getOneTraineesBySectorSaga() {
    yield takeLatest(
        getOneTraineesTypes.GET_ONE_TRAINEES_REQUEST,
        getOneTraineesBySectorSagas
    )
}
